"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function seireki(date, unit) {
    if (unit === void 0) { unit = '年'; }
    return "" + date.getFullYear() + unit;
}
exports.default = seireki;
